import { ChangeEvent, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { useTranslation } from 'react-i18next';
import ApiManager from '../../api/ApiManager';
import Form from 'react-bootstrap/Form'
import Dropdown from 'react-bootstrap/Dropdown'


export default function HeaderSearchBar() {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchedHints, setSearchedHints] = useState([]);
    const [showHints, setShowHints] = useState(false);
    const [timeout, settimout] = useState<NodeJS.Timeout>();

    function time() {
        if (timeout) { clearTimeout(timeout) }
        settimout(setTimeout(() => {
            searchHints()
            setShowHints(true)
        }, 1000))
    }

    useEffect(() => {
        if (searchTerm && searchTerm.length > 2) {
            time()
        }
        else {
            setShowHints(false)
            setSearchedHints([])
        }
        console.log(timeout)
    }, [searchTerm])

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setSearchTerm(e.target.value)
    }

    function search() {
        return window.location.href = '/search?term=' + searchTerm
    }

    async function searchHints() {
        try {
            const currentURL = window.location.href
            const firstSlashIndex = currentURL.indexOf('/', currentURL.indexOf('//') + 2);
            const currentLang = currentURL.slice(firstSlashIndex + 1, firstSlashIndex + 8)
            const response = await ApiManager.search(currentLang, searchTerm)
            setSearchedHints(response)
        }
        catch (error: any) {
            console.error('search hints error: ', error)
        }
    }

    return (
        <div>
            <InputGroup>
                <Form.Control
                    value={searchTerm}
                    onChange={(e) => handleChange(e as ChangeEvent<HTMLInputElement>)}
                    placeholder={t('header.search.placeholder')}
                    className='border-dark-subtle rounded-start-2 focus-ring focus-ring-warning'
                />
                <Button variant='white' className='border-dark-subtle' onClick={() => setSearchTerm('')}>
                    <span className="fw-bold bi bi-x"></span>
                </Button>
                <Button variant='success' onClick={() => search()}>
                    <span className="fw-bold bi bi-search"></span>
                </Button>
            </InputGroup>
            <Dropdown show={showHints} onToggle={() => setShowHints(false)}>
                <Dropdown.Menu>
                    {searchedHints && searchedHints.length > 0
                        ? (<>
                            {searchedHints.map((hint, index) => (
                                <Dropdown.Item key={index} href={hint['url']} className="d-flex align-items-center overflow-hidden text-wrap">
                                    <img src={hint['image']} alt="" className="img-thumbnail me-3" style={{ width: "65px", height: "65px" }} />
                                    {hint['name']}
                                </Dropdown.Item>
                            ))}
                        </>)
                        : (
                            <Dropdown.Item>{t('search.no_results')}</Dropdown.Item>
                        )
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}